import { useState } from "react";
import { Input } from "V2.0/common/input";
import {
  Dialog,
  DialogBody,
  DialogActions,
  DialogTitle,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import SlotTagsAvailable from "./SlotTagsAvailable";

const MAX_SLOT_TAG_LENGTH = 24;

export default function SlotTagInput(props) {
  const { slotTag, onSlotTagUpdate, availableSlotTags, onClose } = props;
  const [tag, setTag] = useState(slotTag);

  const handleAdd = () => {
    onSlotTagUpdate(tag);
    onClose();
  };

  const handleAvailableSlotTagSelect = (slotTag) => {
    onSlotTagUpdate(slotTag);
    onClose();
  };

  const isAddDisabled = tag === "";
  const remainingLength = MAX_SLOT_TAG_LENGTH - tag.length;

  return (
    <Dialog
      open={true}
      onClose={onClose}
    >
      <DialogTitle>Tag</DialogTitle>
      <DialogBody className="flex flex-col gap-y-8">
        <div className="flex flex-col gap-y-1">
          <Input
            type="text"
            name="slot-tag"
            value={tag}
            maxLength={MAX_SLOT_TAG_LENGTH}
            onChange={(e) => setTag(e.target.value.slice(0, MAX_SLOT_TAG_LENGTH).trim())}
          />
          <p
            className={`text-xs text-right ${
              remainingLength <= 0 ? "text-red-500" : "text-gray-400"
            }`}
          >
            {tag.length}/{MAX_SLOT_TAG_LENGTH}
          </p>
        </div>
        <SlotTagsAvailable
          slotTags={availableSlotTags}
          onAvailableSlotTagSelect={handleAvailableSlotTagSelect}
        />
      </DialogBody>
      <DialogActions>
        <Button
          onClick={onClose}
          outline
        >
          Cancel
        </Button>
        <Button
          disabled={isAddDisabled}
          onClick={handleAdd}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}